import { render } from "./EditTabletFormComponentDetails.vue?vue&type=template&id=77359efa"
import script from "./EditTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./EditTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__